export default __webpack_public_path__ + "static/media/primary-logo-text.c4ae845b.svg";